export function isRuntime(x) {
    if (typeof x === "object") {
        if (x.isRuntime === true) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=runtime.js.map